import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonDirective, SpinnerComponent } from '@imagise/shared';
import type { ObjectDetectionBox } from '../../../infrastructure/rendering';
import { PanelLayoutComponent } from '../panel-layout/panel-layout.component';

@Component({
  selector: 'lib-object-detection-panel',
  imports: [ButtonDirective, PanelLayoutComponent, SpinnerComponent, TranslateModule],
  host: { class: 'contents' },
  templateUrl: './object-detection-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObjectDetectionPanelComponent {
  readonly ready = input(false);
  readonly loading = input(false);
  readonly objects = input<readonly ObjectDetectionBox[] | null>(null);
  readonly errorKey = input<string | null>(null);
  readonly downloadUrl = input<string | null>(null);
  readonly detectRequested = output<void>();
  readonly cancelRequested = output<void>();
}
